module.exports = __webpack_public_path__ + "img/builder-5.1ad4ae0b.webp";